import React from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';

import { PageActions, ImageBox, Section, TextArea, TextInput, SwitchInput, ImageInput, EditorInput } from '../components';
import { userActions, generalActions } from '../actions';
import { generalService } from '../services';


class SeoPage extends React.Component {
  constructor(props) {
      super(props);

      this.pid = 1 ; //seo_setting
      this.props.dispatch(generalActions.getContent(0,this.pid));

      this.state = {
      sections:[{
        name: 'general_seo',
        label: 'General SEO',
        description:'All the elements required to increase awareness, improve rankings, and drive traffic in search engines.',
        fields: [
          {
            name: 'seo_title',
            label: 'SEO Title',
            placeholder: 'Enter SEO Title',
            invalid_feedback: 'Pleace Enter SEO Title',
            type: 'text',
            isRequire: true,
            value: ''
          },
          {
            name: 'seo_description',
            label: 'SEO Description',
            placeholder: 'Enter SEO Description',
            invalid_feedback: 'Pleace Enter SEO Description',
            type: 'textArea',
            isRequire: true,
            rows: 5,
            value: ''
          }
        ]
      }],
    }

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);

  }

  componentWillReceiveProps(props){

      const { content } = props;
      const { data, id } = content;

      if(data){
        this.setState({ sections:data, id:id, isLoaded:true });
      }else{
        setTimeout(()=>this.setState({ isLoaded: true}),1000);
      }
  }

  handleChange(e) {
    const { name, value, dataset } = e.target;
    const { sections } = this.state;
    
    let temp_sections = sections;

    temp_sections.find(function (object, index_s) { 
      
      if(object.name === dataset.parent){
      
        object.fields.find(function (object, index_f) {
      
          if(object.name === e.target.name){
      
           temp_sections[index_s].fields[index_f].value = value;
      
          }
      
        });
      
      } 
    });

    this.setState({sections:temp_sections});
  }


  handleSubmit(e) {
    e.preventDefault();
    const { dispatch, content } = this.props;
    const { id } = this.state;
    const data = this.state.sections;

    this.setState({ submitted: true });

    if(id){
      dispatch(generalActions.postContent(data, id, this.pid));  
    }else{
      dispatch(generalActions.putContent(data, this.pid));  
    }
  }

  render() {

    const { sections } = this.state;

    return (
      <div className={this.state.isLoaded ? "content-wrapper" : "content-wrapper loader-light"}>
      {
        this.state.isLoaded ?
        <form role="form" name="contact" className="needs-validation" noValidate="true">
          <section className="content-header clearfix">
            <h1 className="content-header-title">
              General SEO
            </h1>
            <div className="btn-placeholder">
              <button type="submit" className="btn btn-primary" onClick={this.handleSubmit}>
                <span className="visible-xs"><i className="fa fa-check"></i>&nbsp;</span>
                <span className="hidden-xs">Save</span>
              </button>
            </div>
          </section>
          {
            sections && 
            <section className="content">
              {
                sections.map((section, index_s)=>
                  <Section 
                  key={index_s}
                  section_title={section.label}
                  section_description={section.description}>
                  {
                    section.fields.map((field, index_f)=>{
                      switch(field.type){
                        case 'switch': return(<SwitchInput
                                          key={index_f}
                                          input_label={field.label}
                                          input_name={field.name}
                                          input_type={field.type}
                                          input_onChange={this.handleSwitchChange}
                                          input_value={field.value}
                                          input_parent={section.name}
                                        />);break;
                        case 'image': return(<ImageInput
                                              key={index_f}
                                              input_label={field.label}
                                              input_name={field.name}
                                              input_helper={field.helper}
                                              input_onChange={this.handleFileChange}
                                              input_value={field.value}
                                              input_parent={section.name}
                                            />);
                                      break;
                        case 'images': return(<div/>);
                                      break;
                        case 'textEditor': return(<EditorInput
                                    key={index_f}
                                    input_label={field.label}
                                    input_name={field.name}
                                    input_placeholder={field.placeholder}
                                    input_value={field.value}
                                    input_onChange={this.handlePayload}
                                    input_parent={section.name}
                                  />);
                                      break;
                        case 'textArea': return(<TextArea
                                    key={index_f}
                                    input_label={field.label}
                                    input_name={field.name}
                                    input_placeholder={field.placeholder}
                                    input_value={field.value}
                                    input_onChange={this.handlePayload}
                                    input_parent={section.name}
                                    input_rows={field.rows}
                                  />);
                                      break;
                        default : return(<TextInput
                                    key={index_f}
                                    input_label={field.label}
                                    input_placeholder={field.placeholder}
                                    input_invalid_feedback={field.invalid_feedback}
                                    input_name={field.name}
                                    input_type={field.type}
                                    input_is_required={field.isRequire}
                                    input_onChange={this.handleChange}
                                    input_value={field.value}
                                    input_parent={section.name}
                                    input_rows={field.rows}
                                  />);
                                  break;
                      }
                    })
                  }
                  </Section>
                )
              }
            </section>
          }
          </form>
          :
        <div className="loader"></div>
      }
      </div>
    );
  }
}

function mapStateToProps(state) {
    const { authentication, general } = state;
    const { content } = general;
    return {
        content
    };
}

const connectedSeoPage = connect(mapStateToProps)(SeoPage);
export { connectedSeoPage as SeoPage };


// WEBPACK FOOTER //
// ./src/pages/SeoPage.js